@if (order && active) {
	<div (click)="goToOrder()" class="ion-margin wrapper" expand="block">
		<ion-button>
			<div class="quantity">{{ order.orderedArticles.length }}</div>
			{{ 'menu_page.order_btn' | translate }}
		</ion-button>
		<!-- <span class="vertical-line"></span>
        {{ formattedPrice }} -->
	</div>
}
